import React from 'react';
import { useTranslation } from "react-i18next";
import { _t } from "../../../../../functions/Functions";
import DataTable from "../../../../common/DataTable";
import Moment from "react-moment";

const LogModal = ({ show, handleClose, logs = [], title = "Operation Logs" }) => {
  const { t } = useTranslation();

  const columns = [
    {
      header: _t(t("ID")),
      key: "id",
      width: "50px"
    },
    {
      header: _t(t("Tab")),
      key: "pos_tab",
    },
    {
      header: _t(t("POS ID")),
      key: "pos_id",
    },
    {
      header: _t(t("Action")),
      key: "action",
    },
    {
      header: _t(t("Changes")),
      key: "changes",
      render: (item) => (
        <div style={{ maxWidth: "15rem", wordWrap: "break-word"}}>
          {item.changes}
        </div>
      )
    },
    {
      header: _t(t("User Name")),
      key: "user_name",
    },
    {
      header: _t(t("Time")),
      key: "created_at",
      render: (item) => (
        <Moment format="YYYY-MM-DD hh:mm:ss A">
          {item.created_at}
        </Moment>
      )
    }
  ];

  return (
    <div
      className={`modal fade ${show ? "showing" : ""}`}
      style={{ display: show ? "block" : "none", backgroundColor: 'rgba(0,0,0,0.5)' }}
      id="logModal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl mt-2">
        <div className="modal-content">
          <div className="modal-header align-items-center">
            <div>
              <div className="lg-text font-weight-bold">
                {_t(t(title))}
              </div>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body p-0">
            <div className='my-2'>
              <DataTable
                columns={columns}
                data={logs}
                emptyText="No logs found"
                theadClass="modal-scroll"
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              {_t(t("Close"))}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogModal;
